export default {
  plans: [],
  plan: {},
  filterPlans: {}
}



// WEBPACK FOOTER //
// ./src/app/pages/plans/vuex/state.js